<template>
  <vs-popup id="switchScreen" :active.sync="isScreenLock">
    <vs-row vs-type="flex" vs-w="12">
      <vs-col vs-type="flex" vs-w="6">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row
            vs-type="flex"
            vs-w="12"
            vs-justify="center"
            class="mb-1"
            style="position: relative"
          >
            <img class="responsive logo py-5 px-5"  :src="logo"/>

          </vs-row>
          <vs-row vs-type="flex" vs-w="12"
          class="mb-1" vs-justify="center"  style=" align-items: center;">
            <div
              class="bg-white text-primary bold  py-5  px-5"
              style="
                border-radius: 10px;
                border: 1px solid #e1e1e1;
                box-shadow: 0px 3px 6px #00000029;
              "
            >
              Lütfen Şifrenizi Giriniz
            </div>
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-w="6">
        <vs-row vs-type="flex" vs-w="12" vs-justify="center">
          <vs-row vs-type="flex" vs-w="10" class="my-2">
            <form autocomplete="off">
              <input
                autofocus="true"
                id="txtPassword"
                ref="txtPassword"
                name="selfServiceCode"
                autocomplete="off"
                size="large"
                type="password"
                v-model="PIN"
                class="bold w-full pin-text"
              />
            </form>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-w="3"
              vs-offset="0.75"
              v-for="number in numbers"
              :key="number"
              class="my-1"
            >
              <vs-button
                color="transparent"
                @click="PIN.length < 4 ? (PIN = PIN + number) : null"
                class="bg-secondary w-full text-primary bold half-friendly-border py-5"
                style="font-size: 1.4rem"
              >
                {{ number }}
              </vs-button>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-1">
            <vs-col vs-type="flex" vs-w="3" vs-offset="0.75" class="my-1">
              <vs-button
                @click="PIN.length < 4 ? (PIN = PIN + 0) : null"
                color="transparent"
                class="bg-secondary w-full text-primary bold half-friendly-border"
                style="font-size: 1.3rem"
              >
                0
              </vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6.75" vs-offset="0.75"  class="my-1">
              <vs-button
                color="transparent"
                @click="PIN = ''"
                class="bg-secondary w-full text-primary bold half-friendly-border"
                style="font-size: 1.3rem"
              >
                Temizle
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import companyInfo from "../../../model/constants/companyInfo";
export default {
  data() {
    return {
      numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      PIN: "",
      passMask: "####",
      logo: companyInfo.logo,
    };
  },
  methods: {
    checkForPin(val) {
      let personList = this.$store.getters["selfservice/getPersonList"];
      let currentPerson = personList.find((x) => x.userCode === val);
      if (currentPerson) {
        this.$store.dispatch("selfservice/setActivePersonal", currentPerson);
        this.PIN = "";
        this.$vs.notify({
          color: "success",
          title: "Giriş Başarılı !",
          text: " Satışa Hazır !",
        });
        //document.body.requestFullscreen();
        this.isActive = false;
      } else {
        this.$store.dispatch("selfservice/setActivePersonal", currentPerson);
        this.$vs.notify({
          color: "danger",
          title: "PIN BULUNUMADI !",
          text: "Lütfen Doğru PIN Giriniz.",
        });
        this.PIN = "";
      }
    },
    focusInput() {

      this.$refs.txtPassword.focus();
    },
  },
  watch: {
    PIN(val) {
      if (val.length == 4) {
        this.checkForPin(val);
      }
    },
    isScreenLock(val) {
      if (val) {
        this.$nextTick(() => {

          this.focusInput();
        });
      }
    },
  },
  computed: {
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set() {},
    },
  },
  created() {
    this.PIN = "";
    this.$store.dispatch("selfservice/setActivePersonal", null);
  },
};
</script>

<style>

.logo{
  background-color: white;
     border-radius: 10px;
  margin-bottom: 1rem;
}
#switchScreen{
  z-index: 999999;
}
#switchScreen .vs-popup .vs-popup--header {
  display: none !important;
}

#switchScreen .vs-popup .vs-popup--content {
  padding: 0 !important;
  /*height: 47vh;*/
}

#switchScreen .vs-popup {
  background: transparent !important;
  box-shadow: none !important;
}

#switchScreen input {
  font-size: 2rem !important;
  background: #f2f2f2 0% 0% no-repeat padding-box !important;
  text-align: center !important;
  padding: 0.5rem;
}
</style>
